import { HttpClient } from './httpClient';
import { getEnvVariable } from "@/lib/utils/env";;
export type {
    RequestConfig,
    RequestOptions,
    HttpResponse,
    HttpError,
} from './types';
export {
    buildUrl,
    getDefaultHeaders,
    mergeHeaders,
    createTimeoutSignal,
} from './utils';

// Create a default instance
export const httpClient = new HttpClient(getEnvVariable('NEXT_PUBLIC_API_BASE_URL') || '');

